<template>
  <Header />
  <div class="py-2 bg-gradient-to-b from-red-50 to-transparent w-full h-full lg:pb-2 relative">
    <div
v-if="gifts.length >= 5 && $store.state.user.data.plan !== 'paid'"
      class="container min-w-full flex flex-col items-center z-25 "
>
      <button
@click="createCheckoutSession"
        class="mx-1 text-white bg-green-600 hover:bg-green-800 focus:ring-4 focus:outline-none focus:ring-green-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-green-600 dark:hover:bg-red-600 dark:focus:ring-green-800"
        type="button"
>
        <svg
v-if="checkoutLoading" aria-hidden="true" role="status"
          class="inline w-4 h-4 mr-1 text-gray-200 animate-spin dark:text-gray-600" viewBox="0 0 100 101" fill="none"
          xmlns="http://www.w3.org/2000/svg"
>
          <path
            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
            fill="currentColor"
/>
          <path
            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
            fill="#1C64F2"
/>
        </svg>
        Upgrade
      </button>

      <p class="text-center text-red-700 dark:text-gray-400">
        You have reached the maximum number of gifts on our free tier, upgrade your plan ($10 once off) to add unlimited
        gifts!
      </p>
    </div>

    <div v-else class="flex justify-center">
      <div class="w-full max-w-4xl mx-auto px-4">
        <!-- Add Gift Section -->
        <div class="bg-white rounded-xl shadow-lg border border-gray-200 p-6 mb-6">
          <div class="flex flex-col space-y-4">
            <!-- Top Section: Icon, Text, and Add Button -->
            <div class="flex flex-col sm:flex-row sm:items-center space-y-4 sm:space-y-0 sm:space-x-4">
              <!-- Icon and Text Content (grouped together) -->
              <div class="flex items-center space-x-4 flex-1">
                <div
                  class="w-12 h-12 bg-gradient-to-br from-red-500 to-pink-500 rounded-full flex items-center justify-center flex-shrink-0"
>
                  <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path
stroke-linecap="round" stroke-linejoin="round"
                      d="M21 11.25v8.25a1.5 1.5 0 01-1.5 1.5H5.25a1.5 1.5 0 01-1.5-1.5v-8.25M12 4.875A2.625 2.625 0 109.375 7.5H12m0-2.625V7.5m0-2.625A2.625 2.625 0 1114.625 7.5H12m0 0V21m-8.625-9.75h18c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125h-18c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z"
>
                    </path>
                  </svg>
                </div>
                <div class="flex-1">
                  <h3 class="text-lg font-semibold text-gray-900">Gift Ideas</h3>
                  <p class="text-sm text-gray-600">Build your collection of perfect gift ideas</p>
                </div>
              </div>

              <!-- Add Button -->
              <div class="flex justify-center sm:justify-end">
                <button
@click="$router.push('/gift/add')"
                  class="inline-flex items-center px-6 py-3 bg-gradient-to-r from-red-500 to-pink-500 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl hover:from-red-600 hover:to-pink-600 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 transition-all duration-200 transform hover:scale-105 w-full sm:w-auto justify-center sm:justify-start"
>
                  <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path
stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M12 6v6m0 0v6m0-6h6m-6 0H6"
/>
                  </svg>
                  Add Gift
                </button>
              </div>
            </div>

            <!-- Bottom Section: Sort Controls -->
            <div class="flex items-center justify-center sm:justify-end space-x-3 pt-4 border-t border-gray-200">
              <label for="sortby" class="text-sm font-medium text-gray-700 whitespace-nowrap">Sort by:</label>
              <select
id="sortby" v-model="sortBy.value" name="sortby"
                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-red-500 focus:border-red-500 px-3 py-2 min-w-0 flex-1 sm:flex-initial"
>
                <option v-for="option in sortBy.options" :value="option.value" :key="option">
                  {{ option.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="pt-4 space-y-3">
      <hr class="w-full" />
    </div>

    <GiftList :sortby="sortBy.value"></GiftList>

    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/Footer.vue";
import Header from "@/components/Header.vue";
import GiftList from "@/components/GiftList.vue";

import { Auth } from 'aws-amplify';

export default {
  name: "GiftView",
  components: {
    Header,
    Footer,
    GiftList,
  },
  data() {
    return {
      checkoutLoading: false,
      sortBy: {
        value: this.$store.state.giftSort,
        options: [
          { name: "Date Added", value: "updatedAt" },
          { name: "Name", value: "name" },
          { name: "Price", value: "price" },
        ],
      },
    }
  },
  computed: {
    gifts() {
      return this.$store.state.giftMap;
    },
  },
  created() {
    Auth.currentAuthenticatedUser({
      bypassCache: true
    })
      .then((user) => {
        if (user.attributes['custom:plan'] !== this.$store.state.user.data.plan) {
          this.$store.dispatch("fetchUser", user);
        }
      }
      )
      .catch((err) => console.log(err));
  },
  methods: {
    async createCheckoutSession() {
      this.checkoutLoading = true;
      try {
        const response = await fetch('https://api.' + process.env.VUE_APP_ENVIRONMENT + '.presentplanner.co/create-checkout-session', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ email: this.$store.state.user.data.username })
        });
        const data = await response.json();
        const stripe = Stripe(process.env.VUE_APP_STRIPE_PUB_KEY);
        const result = await stripe.redirectToCheckout({ sessionId: data.id });
        if (result.error) {
          console.error(result.error.message);
        }
      } catch (error) {
        console.error("Error: ", error);
      }
    }
  },
};
</script>
